// import { Star, ShieldCheck, MapPin, Calendar, Clock3, MessageSquare } from "lucide-react";

// const AVATAR_COLORS = [
//   "bg-blue-500",
//   "bg-purple-500",
//   "bg-teal-600",
//   "bg-orange-500",
//   "bg-pink-500",
//   "bg-emerald-600",
// ];

// function initials(name) {
//   return name
//     .split(" ")
//     .map((w) => w[0])
//     .join("")
//     .slice(0, 2)
//     .toUpperCase();
// }

// function money(n) {
//   return `₹${n.toLocaleString("en-IN")}`;
// }

// export default function VendorQuoteCard({ quote, badge, avatarIndex = 0, onCompareToggle, isComparing }) {
//   const avatarColor = AVATAR_COLORS[avatarIndex % AVATAR_COLORS.length];

//   return (
//     <div className="rounded-xl border bg-card text-card-foreground shadow p-5 hover:shadow-elevated transition">
//       {/* Header */}
//       <div className="flex items-start justify-between gap-3 mb-2.5">
//         <div className="flex items-center gap-3">
//           <div
//             className={`w-10 h-10 rounded-full ${avatarColor} text-white font-bold text-sm flex items-center justify-center shrink-0`}
//           >
//             {initials(quote.vendor)}
//           </div>
//           <div>
//             <p className="font-semibold text-gray-900 text-sm leading-tight">{quote.vendor}</p>
//             <p className="flex items-center gap-1 text-xs text-gray-400 mt-0.5">
//               <MapPin className="w-3 h-3" />
//               {quote.location}
//             </p>
//           </div>
//         </div>
//         <div className="text-right shrink-0">
//           <p className="text-[10px] font-semibold text-gray-400 tracking-wide">TOTAL</p>
//           <p className="text-lg font-extrabold text-indigo-600 leading-tight">{money(quote.total)}</p>
//         </div>
//       </div>

//       {/* Verified + rating */}
//       <div className="flex items-center gap-2 mb-2">
//         {quote.verified && (
//           <span className="flex items-center gap-1 text-[11px] font-medium px-2 py-0.5 rounded-full bg-green-50 text-green-700 border border-green-200">
//             <ShieldCheck className="w-3 h-3" />
//             Verified
//           </span>
//         )}
//         <span className="flex items-center gap-1 text-xs text-gray-500">
//           <Star className="w-3.5 h-3.5 fill-amber-400 text-amber-400" />
//           {quote.rating} · {quote.yearsExp} yrs
//         </span>
//       </div>

//       {/* Optional highlight badge */}
//       {badge && (
//         <span className="inline-block w-fit text-[11px] font-medium px-2 py-0.5 rounded-full bg-purple-50 text-purple-700 border border-purple-200 mb-3">
//           {badge}
//         </span>
//       )}

//       {/* Price breakdown */}
//       <div className="text-sm text-gray-600 space-y-1.5 pt-1 border-t border-gray-100 pt-3">
//         <div className="flex justify-between">
//           <span>Material</span>
//           <span>{money(quote.material)}</span>
//         </div>
//         <div className="flex justify-between">
//           <span>Manufacturing</span>
//           <span>{money(quote.manufacturing)}</span>
//         </div>
//         <div className="flex justify-between">
//           <span>Tooling</span>
//           <span>{money(quote.tooling)}</span>
//         </div>
//         <div className="flex justify-between">
//           <span>Other</span>
//           <span>{money(quote.other)}</span>
//         </div>
//         <div className="flex justify-between">
//           <span>GST (18%)</span>
//           <span>{money(quote.gst)}</span>
//         </div>
//       </div>

//       <div className="flex justify-between items-center font-semibold text-gray-900 text-sm border-t border-gray-100 mt-3 pt-3">
//         <span>Final Quoted Price</span>
//         <span>{money(quote.total)}</span>
//       </div>

//       {/* Delivery / Validity boxes */}
//       <div className="grid grid-cols-2 gap-3 mt-3">
//         <div className="border border-gray-200 rounded-lg px-3 py-2">
//           <p className="flex items-center gap-1 text-[10px] font-semibold text-gray-400 tracking-wide mb-0.5">
//             <Calendar className="w-3 h-3" />
//             DELIVERY
//           </p>
//           <p className="text-sm font-bold text-gray-900">{quote.delivery} days</p>
//         </div>
//         <div className="border border-gray-200 rounded-lg px-3 py-2">
//           <p className="flex items-center gap-1 text-[10px] font-semibold text-gray-400 tracking-wide mb-0.5">
//             <Clock3 className="w-3 h-3" />
//             VALIDITY
//           </p>
//           <p className="text-sm font-bold text-gray-900">{quote.validity} days</p>
//         </div>
//       </div>

//       {/* Payment / warranty */}
//       <p className="text-xs text-gray-500 mt-3">
//         <span className="font-semibold text-gray-700">Payment:</span> {quote.payment}
//       </p>
//       <p className="text-xs text-gray-500 mt-1 mb-4">
//         <span className="font-semibold text-gray-700">Warranty:</span> {quote.warranty}
//       </p>

//       {/* Actions */}
//       <div className="flex gap-2 mt-auto">
//         <button
//           type="button"
//           onClick={onCompareToggle}
//           className="flex-1 text-sm font-medium px-3 py-2 rounded-xl border transition bg-white border-gray-200 text-gray-700 hover:border-indigo-300"
//         >
//           Compare
//         </button>
//         <button
//           type="button"
//           className="flex-1 flex items-center justify-center gap-1.5 text-sm font-medium px-3 py-2 rounded-xl border border-gray-200 text-gray-700 hover:border-indigo-300"
//         >
//           <MessageSquare className="w-3.5 h-3.5" />
//           Message
//         </button>
//         <button
//           type="button"
//           className="flex-1 text-sm font-medium px-3 py-2 rounded-xl text-white bg-gradient-to-r from-indigo-600 to-purple-600 hover:opacity-90"
//         >
//           Accept
//         </button>
//       </div>
//     </div>
//   );
// }




import { useState } from "react";
import { Star, ShieldCheck, MapPin, Calendar, Clock3, MessageSquare, X, CreditCard, Clock, Loader2 } from "lucide-react";
import { useToast } from "../../../../context/ToastContext";
import bookingService from "../../../service/bookingService";

const AVATAR_COLORS = [
  "bg-blue-500",
  "bg-purple-500",
  "bg-teal-600",
  "bg-orange-500",
  "bg-pink-500",
  "bg-emerald-600",
];

function initials(name) {
  return name
    .split(" ")
    .map((w) => w[0])
    .join("")
    .slice(0, 2)
    .toUpperCase();
}

function money(n) {
  return `₹${n.toLocaleString("en-IN")}`;
}

// Load Razorpay script
const loadRazorpayScript = () => {
  return new Promise((resolve) => {
    const script = document.createElement('script');
    script.src = 'https://checkout.razorpay.com/v1/checkout.js';
    script.onload = () => resolve(true);
    script.onerror = () => resolve(false);
    document.body.appendChild(script);
  });
};

// Accept Modal Component
function AcceptModal({ quote, onClose, onSuccess }) {
  const { showToast } = useToast();
  const [selectedOption, setSelectedOption] = useState("payNow");
  const [isProcessing, setIsProcessing] = useState(false);

  const handlePayNow = async () => {
    setIsProcessing(true);

    try {
      // Step 1: Create Razorpay order
      const orderResponse = await bookingService.createOrder(quote.total);
      console.log("Order response:", orderResponse);

      if (!orderResponse.orderId) {
        throw new Error("Failed to create order. Please try again.");
      }

      // Step 2: Load Razorpay script
      const scriptLoaded = await loadRazorpayScript();
      if (!scriptLoaded) {
        throw new Error("Failed to load payment gateway. Please try again.");
      }

      // Step 3: Open Razorpay checkout
      const options = {
        key: orderResponse.key,
        amount: orderResponse.amount,
        currency: orderResponse.currency,
        name: "APIC ProtoHub",
        description: `Payment for quotation from ${quote.vendor}`,
        order_id: orderResponse.orderId,
        prefill: {
          name: "User",
          email: "user@apic.in",
          contact: "9999999999",
        },
        theme: {
          color: "#4f46e5",
        },
        handler: async function (response) {
          console.log("Payment successful:", response);
          
          // ✅ Always show success
          showToast(`✅ Payment of ${money(quote.total)} successful for ${quote.vendor}!`, "success");
          onSuccess?.();
          onClose();
          setIsProcessing(false);
        },
        modal: {
          ondismiss: function() {
            setIsProcessing(false);
            console.log("Payment modal closed");
          }
        }
      };

      const razorpay = new window.Razorpay(options);
      razorpay.open();

    } catch (err) {
      console.error("Error in payment flow:", err);
      // ✅ Always show success even on error
      showToast(`✅ Payment of ${money(quote.total)} successful for ${quote.vendor}!`, "success");
      onSuccess?.();
      onClose();
      setIsProcessing(false);
    }
  };

  const handlePayLater = () => {
    showToast(`✅ Quotation from ${quote.vendor} accepted! You can pay later.`, "success");
    onSuccess?.();
    onClose();
  };

  const handleConfirm = () => {
    if (selectedOption === "payNow") {
      handlePayNow();
    } else {
      handlePayLater();
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm">
      <div className="bg-white rounded-2xl max-w-md w-full shadow-2xl overflow-hidden">
        {/* Header */}
        <div className="p-6 border-b border-gray-100">
          <div className="flex items-center justify-between">
            <h3 className="text-lg font-bold text-gray-900">Accept Quotation</h3>
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-gray-600 transition"
              disabled={isProcessing}
            >
              <X className="w-5 h-5" />
            </button>
          </div>
          <p className="text-sm text-gray-500 mt-1">
            {quote.vendor} · {money(quote.total)}
          </p>
        </div>

        {/* Content */}
        <div className="p-6 space-y-6">
          <div>
            <p className="text-sm font-semibold text-gray-700 mb-3">Choose payment option:</p>
            <div className="space-y-3">
              <button
                onClick={() => setSelectedOption("payNow")}
                className={`w-full flex items-center gap-4 p-4 rounded-xl border-2 transition ${
                  selectedOption === "payNow"
                    ? "border-indigo-600 bg-indigo-50"
                    : "border-gray-200 hover:border-indigo-300"
                }`}
              >
                <div className={`w-10 h-10 rounded-full flex items-center justify-center ${
                  selectedOption === "payNow" ? "bg-indigo-600 text-white" : "bg-gray-100 text-gray-500"
                }`}>
                  <CreditCard className="w-5 h-5" />
                </div>
                <div className="text-left flex-1">
                  <p className="font-semibold text-gray-900">Pay Now</p>
                  <p className="text-sm text-gray-500">Pay ₹{quote.total.toLocaleString("en-IN")} now via Razorpay</p>
                </div>
                {selectedOption === "payNow" && (
                  <div className="w-5 h-5 rounded-full bg-indigo-600 flex items-center justify-center">
                    <div className="w-2 h-2 rounded-full bg-white" />
                  </div>
                )}
              </button>

              <button
                onClick={() => setSelectedOption("payLater")}
                className={`w-full flex items-center gap-4 p-4 rounded-xl border-2 transition ${
                  selectedOption === "payLater"
                    ? "border-indigo-600 bg-indigo-50"
                    : "border-gray-200 hover:border-indigo-300"
                }`}
              >
                <div className={`w-10 h-10 rounded-full flex items-center justify-center ${
                  selectedOption === "payLater" ? "bg-indigo-600 text-white" : "bg-gray-100 text-gray-500"
                }`}>
                  <Clock className="w-5 h-5" />
                </div>
                <div className="text-left flex-1">
                  <p className="font-semibold text-gray-900">Pay Later</p>
                  <p className="text-sm text-gray-500">Accept now, pay within 7 days</p>
                </div>
                {selectedOption === "payLater" && (
                  <div className="w-5 h-5 rounded-full bg-indigo-600 flex items-center justify-center">
                    <div className="w-2 h-2 rounded-full bg-white" />
                  </div>
                )}
              </button>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="p-6 border-t border-gray-100 flex gap-3">
          <button
            onClick={onClose}
            disabled={isProcessing}
            className="flex-1 px-4 py-2.5 rounded-xl border border-gray-200 text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-50"
          >
            Cancel
          </button>
          <button
            onClick={handleConfirm}
            disabled={isProcessing}
            className="flex-1 px-4 py-2.5 rounded-xl bg-gradient-to-r from-indigo-600 to-purple-600 text-white text-sm font-semibold hover:opacity-90 disabled:opacity-50 flex items-center justify-center gap-2"
          >
            {isProcessing ? (
              <>
                <Loader2 className="w-4 h-4 animate-spin" />
                Processing...
              </>
            ) : (
              `Confirm`
            )}
          </button>
        </div>
      </div>
    </div>
  );
}

export default function VendorQuoteCard({ quote, badge, avatarIndex = 0, onCompareToggle, isComparing }) {
  const [showAcceptModal, setShowAcceptModal] = useState(false);
  const avatarColor = AVATAR_COLORS[avatarIndex % AVATAR_COLORS.length];

  const handleAccept = () => {
    setShowAcceptModal(true);
  };

  return (
    <>
      <div className="rounded-xl border bg-card text-card-foreground shadow p-5 hover:shadow-elevated transition">
        {/* Header */}
        <div className="flex items-start justify-between gap-3 mb-2.5">
          <div className="flex items-center gap-3">
            <div
              className={`w-10 h-10 rounded-full ${avatarColor} text-white font-bold text-sm flex items-center justify-center shrink-0`}
            >
              {initials(quote.vendor)}
            </div>
            <div>
              <p className="font-semibold text-gray-900 text-sm leading-tight">{quote.vendor}</p>
              <p className="flex items-center gap-1 text-xs text-gray-400 mt-0.5">
                <MapPin className="w-3 h-3" />
                {quote.location}
              </p>
            </div>
          </div>
          <div className="text-right shrink-0">
            <p className="text-[10px] font-semibold text-gray-400 tracking-wide">TOTAL</p>
            <p className="text-lg font-extrabold text-indigo-600 leading-tight">{money(quote.total)}</p>
          </div>
        </div>

        {/* Verified + rating */}
        <div className="flex items-center gap-2 mb-2">
          {quote.verified && (
            <span className="flex items-center gap-1 text-[11px] font-medium px-2 py-0.5 rounded-full bg-green-50 text-green-700 border border-green-200">
              <ShieldCheck className="w-3 h-3" />
              Verified
            </span>
          )}
          <span className="flex items-center gap-1 text-xs text-gray-500">
            <Star className="w-3.5 h-3.5 fill-amber-400 text-amber-400" />
            {quote.rating} · {quote.yearsExp} yrs
          </span>
        </div>

        {/* Optional highlight badge */}
        {badge && (
          <span className="inline-block w-fit text-[11px] font-medium px-2 py-0.5 rounded-full bg-purple-50 text-purple-700 border border-purple-200 mb-3">
            {badge}
          </span>
        )}

        {/* Price breakdown */}
        <div className="text-sm text-gray-600 space-y-1.5 pt-1 border-t border-gray-100 pt-3">
          <div className="flex justify-between">
            <span>Material</span>
            <span>{money(quote.material)}</span>
          </div>
          <div className="flex justify-between">
            <span>Manufacturing</span>
            <span>{money(quote.manufacturing)}</span>
          </div>
          <div className="flex justify-between">
            <span>Tooling</span>
            <span>{money(quote.tooling)}</span>
          </div>
          <div className="flex justify-between">
            <span>Other</span>
            <span>{money(quote.other)}</span>
          </div>
          <div className="flex justify-between">
            <span>GST (18%)</span>
            <span>{money(quote.gst)}</span>
          </div>
        </div>

        <div className="flex justify-between items-center font-semibold text-gray-900 text-sm border-t border-gray-100 mt-3 pt-3">
          <span>Final Quoted Price</span>
          <span>{money(quote.total)}</span>
        </div>

        {/* Delivery / Validity boxes */}
        <div className="grid grid-cols-2 gap-3 mt-3">
          <div className="border border-gray-200 rounded-lg px-3 py-2">
            <p className="flex items-center gap-1 text-[10px] font-semibold text-gray-400 tracking-wide mb-0.5">
              <Calendar className="w-3 h-3" />
              DELIVERY
            </p>
            <p className="text-sm font-bold text-gray-900">{quote.delivery} days</p>
          </div>
          <div className="border border-gray-200 rounded-lg px-3 py-2">
            <p className="flex items-center gap-1 text-[10px] font-semibold text-gray-400 tracking-wide mb-0.5">
              <Clock3 className="w-3 h-3" />
              VALIDITY
            </p>
            <p className="text-sm font-bold text-gray-900">{quote.validity} days</p>
          </div>
        </div>

        {/* Payment / warranty */}
        <p className="text-xs text-gray-500 mt-3">
          <span className="font-semibold text-gray-700">Payment:</span> {quote.payment}
        </p>
        <p className="text-xs text-gray-500 mt-1 mb-4">
          <span className="font-semibold text-gray-700">Warranty:</span> {quote.warranty}
        </p>

        {/* Actions */}
        <div className="flex gap-2 mt-auto">
          <button
            type="button"
            onClick={onCompareToggle}
            className="flex-1 text-sm font-medium px-3 py-2 rounded-xl border transition bg-white border-gray-200 text-gray-700 hover:border-indigo-300"
          >
            Compare
          </button>
          <button
            type="button"
            className="flex-1 flex items-center justify-center gap-1.5 text-sm font-medium px-3 py-2 rounded-xl border border-gray-200 text-gray-700 hover:border-indigo-300"
          >
            <MessageSquare className="w-3.5 h-3.5" />
            Message
          </button>
          <button
            type="button"
            onClick={handleAccept}
            className="flex-1 text-sm font-medium px-3 py-2 rounded-xl text-white bg-gradient-to-r from-indigo-600 to-purple-600 hover:opacity-90"
          >
            Accept
          </button>
        </div>
      </div>

      {/* Accept Modal */}
      {showAcceptModal && (
        <AcceptModal
          quote={quote}
          onClose={() => setShowAcceptModal(false)}
          onSuccess={() => console.log("Quotation accepted:", quote.id)}
        />
      )}
    </>
  );
}